import axios from "axios";

// 🔥 Automatically detect environment
const API_URL =
  process.env.NODE_ENV === "development"
    ? `http://${window.location.hostname === 'localhost' ? 'localhost' : '127.0.0.1'}:8000/api`
    : "https://vergaraapi.vergararentals.com/api";   // Hostinger Laravel

const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// 🔐 Automatically attach JWT token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
